import { contratoApi } from '../../utils/api';
import {
  getObjectDataAction,
  createObjectDataPending,
  getListDataAction,
  saveObjectDataAction,
  deleteObjectDataAction,
  getListDeletedDataAction,
  createListDataDeletedPending,
  restoreObjectDataAction,
  getListByParentDataAction,
} from '../../utils/DataAction';

export const get = (id) =>
  getObjectDataAction({
    dataName: 'CONTRATO',
    api: contratoApi,
    relUrl: id,
  });

export const getAllByParent = (id) =>
  getListByParentDataAction({
    dataName: 'CONTRATO',
    api: contratoApi,
    relUrl: `indexByParent/${id}`,
  });

export const getAll = getListDataAction({
  dataName: 'CONTRATO',
  api: contratoApi,
  relUrl: '',
});

export const save = (data) =>
  saveObjectDataAction({
    dataName: 'CONTRATO',
    api: contratoApi,
    relUrl: '',
    data: data,
  });

export const deleted = (id) =>
  deleteObjectDataAction({
    dataName: 'CONTRATO',
    api: contratoApi,
    relUrl: id,
  });

export const getAllDeleted = getListDeletedDataAction({
  dataName: 'CONTRATO',
  api: contratoApi,
  relUrl: 'restore',
});

export const restore = (data) =>
  restoreObjectDataAction({
    dataName: 'CONTRATO',
    api: contratoApi,
    relUrl: 'restore',
    data: data,
  });

export const setPending = createObjectDataPending('CONTRATO');
export const setDeletedPending = createListDataDeletedPending('CONTRATO');
